<template>
  <page-header-wrapper>
    <div slot="extra">
      <go-back />
    </div>
    <a-card :body-style="{ padding: '24px 32px' }" :bordered="false">
      <a-form :form="form">
        <a-form-item label="标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['title', { rules: [{ required: true, message: '请输入名称' }] }]"
            name="title"
            placeholder="请输入名称"
          />
        </a-form-item>
        <a-form-item label="所属分类" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-spin :spinning="selectLoading">
            <a-select
              placeholder="请选择分类"
              style="width: 100%"
              name="itid"
              optionFilterProp="children"
              allow-clear
              v-decorator="['itid', { rules: [{ required: true, message: '请选择分类' }] }]"
            >
              <a-select-option v-for="d in selectList" :key="d.id" :value="d.id">{{ d.name }}</a-select-option>
            </a-select>
          </a-spin>
        </a-form-item>
        <a-form-item label="PDF上传" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <file-upload
            name="putl"
            v-decorator="['putl', { rules: [{ required: true, message: '请上传PDF' }] }]"
          />
        </a-form-item>
        <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol" help="默认0，值越大越靠前">
          <a-input-number
            name="sort"
            v-decorator="[
              'sort',
              {
                initialValue: 0
              }
            ]"
          />
        </a-form-item>
        <a-form-item :wrapperCol="{ span: 24 }" style="text-align: center">
          <a-button
            :loading="formLoading"
            type="primary"
            @click="handleSubmit(setFormData)"
          >提交</a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { UEditor, GoBack, FileUpload } from '@/components'
import { form, select } from '@/mixins'
const fields = ['date', 'state', 'title', 'itid', 'putl', 'sort']
const apiList = {
    getInfo: '/info/finds/',
    create: '/info/create',
    update: '/info/',
    selectList: '/info/categories/select'
}
export default {
    name: 'informationForm',
    mixins: [form, select],
    components: {
        UEditor,
        GoBack,
        FileUpload
    },
    data () {
        return {
            apiList,
            fields,
            selectLoading: false, // 分类下拉加载
            selectList: [] // 分类下拉数据
        }
    },
    mounted () {
        const that = this
        if (that.$route.params.id) {
            that.getFormData(that.$route.params.id, function (values) {
                values.date = that.moment(values.date) // 日期格式转换
                values.state = values.state === 1 // 状态格式转换
            }) // 获取编辑信息
        }
        that.getSelectLists({
            url: apiList.selectList
        }) // 获取下拉分类列表
    },
    methods: {
        /**
         * @Author: JDY
         * @Date: 2021-04-25 16:14:35
         * @LastEditTime: Do not edit
         * @LastEditors: JDY
         * @Description:整理表单数据
         * @param  {*}
         * @return {*}
         * @param {*} values
         */
        setFormData (values) {
            values.date = this.moment(values.date).format('YYYY-MM-DD') // 日期格式转换
            // values.state = values.state ? 1 : 2 // 状态 1正常 2隐藏
            console.log('values:')
            console.log(values)
        }
    }
}
</script>
